import React from "react";
import { ProductImageDetailsRootScreenContextType } from "./types";

export const ProductImageDetailsRootScreenContext = React.createContext<
  ProductImageDetailsRootScreenContextType | undefined
>(undefined);
